export default {
    active: "is-active",
    inactive: "is-inactive",
    hidden: "is-hidden"
};
